import { instance } from 'services';
import {
  IFindFnReturn,
  IGenericPayload,
  IGenericResource,
  IQueryParams,
  IResponse,
} from 'services/types.d';

export const DifferentiationResources = {
  findAll: (p?: IQueryParams): Promise<IFindFnReturn<IGenericResource>> =>
    instance.get('/differentiation/', { params: p }),

  create: (params: IGenericPayload): Promise<IResponse<IGenericResource>> =>
    instance.post(`/differentiation/`, params),

  update: (
    id: number,
    params: IGenericPayload,
  ): Promise<IResponse<IGenericResource>> =>
    instance.patch(`/differentiation/${id}/`, params),

  delete: (id: number): Promise<IResponse<unknown>> =>
    instance.delete(`/differentiation/${id}/`),
};
